import axios from 'axios';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getAemContentThunk } from 'state/aem-content/aem-content-thunks';

export const useAemContent = (pageId) => {
  const dispatch = useDispatch();
  useEffect(() => {
    const source = axios.CancelToken.source();
    const requestConfig = { cancelToken: source.token };
    const callApi = async () => {
      await dispatch(getAemContentThunk(pageId, requestConfig));
    };
    callApi();
  }, [dispatch, pageId]);
};
